export const kpiData = [
  {name: 'ValidationSpeed', type: 1, translationKey: 'debtor.dashboard.kpis.validationScore'},
  {name: 'AverageOverdueDays', type: 2, translationKey: 'debtor.dashboard.kpis.averageOverdueDays'},
  {name: 'PaymentSpeed', type: 1, translationKey: 'debtor.dashboard.kpis.paymentSpeed'},
  {name: 'ResponsivenessScore', type: 1, translationKey: 'debtor.dashboard.kpis.responsivenessScore'}
];
